import homepage from './homePage'
import examGrade from './examGrade'
import studentSpace from './studentSpace'
import report from './report'
import price from './commitPrice'
import paper from './commitPaper'
import result from './result'
import applyInvoice from './applyInvoice'
import invoiceResult from './invoiceResult'
import payResult from './payResult'
import studentApplyInvoice from './studentApplyInvoice'
import studentInvoiceResult from './studentInvoiceResult'
import studentPayResult from './studentPayResult'
import studentApplyResult from './studentApplyResult'
const signUp = {
  path: 'signUp',
  component: resolve => require(['../../../components/pages/signUp'], resolve),
  redirect: 'signUp/homePage',
  children: [
    homepage,
    examGrade,
    studentSpace,
    report,
    price,
    paper,
    result,
    applyInvoice,
    invoiceResult,
    payResult,
    studentApplyInvoice,
    studentInvoiceResult,
    studentPayResult,
    studentApplyResult
  ]
}
export default signUp
